import axios from 'axios'

const MODULE_MANAGER_URL =
  import.meta.env.VITE_MODULE_MANAGER_URL ||
  'https://module-manager.trbotrkr.com'

const api = axios.create({
  baseURL: `${MODULE_MANAGER_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default api
